module.exports = __webpack_public_path__ + "static/img/award-6.c719403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-6.jpg
// module id = kfLT
// module chunks = 1